<template>
  <el-dialog :title="$t('buildingManage.add.title')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.add.name')" prop="name">
            <el-input v-model="form.name" :placeholder="$t('buildingManage.add.namePlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.add.intro')" prop="intro">
            <el-input v-model="form.intro" :placeholder="$t('buildingManage.add.introPlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.add.tags')" prop="tags">
            <el-input v-model="form.tags" :placeholder="$t('buildingManage.add.tagsPlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.add.discountInfo')" prop="discountInfo">
            <el-input v-model="form.discountInfo" :placeholder="$t('buildingManage.add.discountInfoPlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.add.coverImg')" prop="coverImg">
            <upload-image-url ref="coverImage" :limit="1" @notifyUploadCoverImage="handleCoverImageChange" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.add.headerImg')" prop="headerImg">
            <upload-image-url ref="headerImage" :limit="1" @notifyUploadCoverImage="handleHeaderImageChange" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.add.unitPrice')" prop="unitPrice">
            <el-input v-model="form.unitPrice" :placeholder="$t('buildingManage.add.unitPricePlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.add.totalPrice')" prop="totalPrice">
            <el-input v-model="form.totalPrice" :placeholder="$t('buildingManage.add.totalPricePlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.add.salesStatus')" prop="salesStatus">
            <el-select v-model="form.salesStatus" :placeholder="$t('buildingManage.add.salesStatusPlaceholder')"
              style="width:100%">
              <el-option :label="$t('buildingManage.salesStatusOptions.toBeSold')" value="待售" />
              <el-option :label="$t('buildingManage.salesStatusOptions.onSale')" value="在售" />
              <el-option :label="$t('buildingManage.salesStatusOptions.soldOut')" value="售罄" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.add.houseType')" prop="houseType">
            <el-input v-model="form.houseType" :placeholder="$t('buildingManage.add.houseTypePlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.add.buildingType')" prop="buildingType">
            <el-input v-model="form.buildingType" :placeholder="$t('buildingManage.add.buildingTypePlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.add.propertyRight')" prop="propertyRight">
            <el-input v-model="form.propertyRight" :placeholder="$t('buildingManage.add.propertyRightPlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item :label="$t('buildingManage.add.address')" prop="address">
        <el-input v-model="form.address" :placeholder="$t('buildingManage.add.addressPlaceholder')" />
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.add.lat')" prop="lat">
            <el-input v-model="form.lat" :placeholder="$t('buildingManage.add.latPlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingManage.add.lng')" prop="lng">
            <el-input v-model="form.lng" :placeholder="$t('buildingManage.add.lngPlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item :label="$t('buildingManage.add.buildingDesc')" prop="buildingDesc">
        <rich-text-editor ref="buildingDescEditor" v-model="form.buildingDesc" />
      </el-form-item>

      <el-form-item :label="$t('buildingManage.add.houseInfo')" prop="houseInfo">
        <div class="house-info-container">
          <div 
            v-for="(house, index) in form.houseInfo" 
            :key="index" 
            class="house-item"
          >
            <el-row :gutter="20">
              <el-col :span="4">
                <el-form-item 
                  :prop="'houseInfo.' + index + '.img'"
                  :rules="{ required: true, message: $t('buildingManage.validate.houseImgRequired'), trigger: 'blur' }"
                >
                  <upload-image-url 
                    :ref="'houseImage_' + index"
                    :limit="1"
                    @notifyUploadCoverImage="(images) => handleHouseImageChange(index, images)"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item 
                  :prop="'houseInfo.' + index + '.name'"
                  :rules="{ required: true, message: $t('buildingManage.validate.houseNameRequired'), trigger: 'blur' }"
                >
                  <el-input 
                    v-model="house.name" 
                    :placeholder="$t('buildingManage.add.houseNamePlaceholder')" 
                    :maxlength="50"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item 
                  :prop="'houseInfo.' + index + '.size'"
                  :rules="{ required: true, message: $t('buildingManage.validate.houseSizeRequired'), trigger: 'blur' }"
                >
                  <el-input 
                    v-model="house.size" 
                    :placeholder="$t('buildingManage.add.houseSizePlaceholder')" 
                    :maxlength="50"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item 
                  :prop="'houseInfo.' + index + '.state'"
                  :rules="{ required: true, message: $t('buildingManage.validate.houseStateRequired'), trigger: 'blur' }"
                >
                  <el-input 
                    v-model="house.state" 
                    :placeholder="$t('buildingManage.add.houseStatePlaceholder')" 
                    :maxlength="50"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item 
                  :prop="'houseInfo.' + index + '.price'"
                >
                  <el-input 
                    v-model="house.price" 
                    :placeholder="$t('buildingManage.add.housePricePlaceholder')" 
                    :maxlength="50"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-button 
                    type="danger" 
                    icon="el-icon-delete" 
                    circle 
                    @click="removeHouse(index)"
                  ></el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          
          <el-button 
            type="primary" 
            icon="el-icon-plus" 
            @click="addHouse"
          >
            {{ $t('buildingManage.add.addHouse') }}
          </el-button>
        </div>
      </el-form-item>

      <el-form-item :label="$t('buildingManage.add.salesInfo')" prop="salesInfo">
        <div class="sales-info-container">
          <div 
            v-for="(sale, index) in form.salesInfo" 
            :key="index" 
            class="sales-item"
          >
            <el-row :gutter="20">
              <el-col :span="5">
                <el-form-item 
                  :prop="'salesInfo.' + index + '.name'"
                  :rules="{ required: true, message: $t('buildingManage.validate.saleNameRequired'), trigger: 'blur' }"
                >
                  <el-input 
                    v-model="sale.name" 
                    :placeholder="$t('buildingManage.add.saleNamePlaceholder')" 
                    :maxlength="50"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item>
                  <upload-image-url 
                    :ref="'saleHeadImage_' + index"
                    :limit="1"
                    @notifyUploadCoverImage="(images) => handleSaleHeadImageChange(index, images)"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item 
                  :prop="'salesInfo.' + index + '.job'"
                  :rules="{ required: true, message: $t('buildingManage.validate.saleJobRequired'), trigger: 'blur' }"
                >
                  <el-input 
                    v-model="sale.job" 
                    :placeholder="$t('buildingManage.add.saleJobPlaceholder')" 
                    :maxlength="50"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item 
                  :prop="'salesInfo.' + index + '.tel'"
                  :rules="{ required: true, message: $t('buildingManage.validate.saleTelRequired'), trigger: 'blur' }"
                >
                  <el-input 
                    v-model="sale.tel" 
                    :placeholder="$t('buildingManage.add.saleTelPlaceholder')" 
                    :maxlength="20"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-button 
                    type="danger" 
                    icon="el-icon-delete" 
                    circle 
                    @click="removeSale(index)"
                  ></el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          
          <el-button 
            type="primary" 
            icon="el-icon-plus" 
            @click="addSale"
          >
            {{ $t('buildingManage.add.addSale') }}
          </el-button>
        </div>
      </el-form-item>

      <el-form-item :label="$t('buildingManage.add.features')" prop="features">
        <rich-text-editor ref="featuresEditor" v-model="form.features" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.submit') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { saveBuilding } from '@/api/oa/buildingManageApi'
import UploadImageUrl from '@/components/upload/UploadImageUrl'
import RichTextEditor from "@/components/editor/RichTextEditor";

export default {
  name: 'AddBuilding',
  components: {
    UploadImageUrl,
    RichTextEditor
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        name: '',
        intro: '',
        tags: '',
        unitPrice: '',
        coverImg: '',
        headerImg: '',
        totalPrice: '',
        discountInfo: '',
        salesStatus: '',
        houseType: '',
        buildingType: '',
        propertyRight: '',
        buildingDesc: '',
        houseInfo: [], // 修改为数组
        salesInfo: [],
        features: '',
        lat: '',
        lng: '',
        address: '',
        communityId: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('buildingManage.validate.nameRequired'), trigger: 'blur' },
          { max: 100, message: this.$t('buildingManage.validate.nameMaxLength'), trigger: 'blur' }
        ],
        intro: [
          { max: 100, message: this.$t('buildingManage.validate.introMaxLength'), trigger: 'blur' }
        ],
        tags: [
          { max: 100, message: this.$t('buildingManage.validate.tagsMaxLength'), trigger: 'blur' }
        ],
        unitPrice: [
          { max: 50, message: this.$t('buildingManage.validate.unitPriceMaxLength'), trigger: 'blur' }
        ],
        coverImg: [
          { max: 255, message: this.$t('buildingManage.validate.coverImgMaxLength'), trigger: 'blur' }
        ],
        headerImg: [
          { max: 255, message: this.$t('buildingManage.validate.headerImgMaxLength'), trigger: 'blur' }
        ],
        totalPrice: [
          { max: 255, message: this.$t('buildingManage.validate.totalPriceMaxLength'), trigger: 'blur' }
        ],
        discountInfo: [
          { max: 255, message: this.$t('buildingManage.validate.discountInfoMaxLength'), trigger: 'blur' }
        ],
        salesStatus: [
          { required: false, message: this.$t('buildingManage.validate.salesStatusRequired'), trigger: 'change' },
          { max: 50, message: this.$t('buildingManage.validate.salesStatusMaxLength'), trigger: 'blur' }
        ],
        houseType: [
          { max: 100, message: this.$t('buildingManage.validate.houseTypeMaxLength'), trigger: 'blur' }
        ],
        buildingType: [
          { max: 255, message: this.$t('buildingManage.validate.buildingTypeMaxLength'), trigger: 'blur' }
        ],
        propertyRight: [
          { max: 255, message: this.$t('buildingManage.validate.propertyRightMaxLength'), trigger: 'blur' }
        ],
        address: [
          { max: 255, message: this.$t('buildingManage.validate.addressMaxLength'), trigger: 'blur' }
        ],
        lat: [
          { max: 20, message: this.$t('buildingManage.validate.latMaxLength'), trigger: 'blur' }
        ],
        lng: [
          { max: 20, message: this.$t('buildingManage.validate.lngMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
        this.$refs.coverImage && this.$refs.coverImage.clearImages()
        this.$refs.headerImage && this.$refs.headerImage.clearImages()
      })
    },
    handleCoverImageChange(images) {
      this.form.coverImg = images.length > 0 ? images[0] : ''
    },
    handleHeaderImageChange(images) {
      this.form.headerImg = images.length > 0 ? images[0] : ''
    },
    // 新增销售头像图片处理方法
    handleSaleHeadImageChange(index, images) {
      this.$set(this.form.salesInfo[index], 'head', images.length > 0 ? images[0] : '')
    },
    // 房型图片处理方法
    handleHouseImageChange(index, images) {
      this.$set(this.form.houseInfo[index], 'img', images.length > 0 ? images[0] : '')
    },
    // 添加销售人员
    addSale() {
      this.form.salesInfo.push({
        name: '',
        head: '',
        job: '',
        tel: ''
      })
    },
    // 删除销售人员
    removeSale(index) {
      this.form.salesInfo.splice(index, 1)
      
      // 清理对应的图片引用
      this.$nextTick(() => {
        const refKey = 'saleHeadImage_' + index
        if (this.$refs[refKey]) {
          this.$refs[refKey][0].clearImages()
        }
      })
    },
    // 添加房型
    addHouse() {
      this.form.houseInfo.push({
        name: '',
        img: '',
        size: '',
        state: '',
        price: ''
      })
    },
    // 删除房型
    removeHouse(index) {
      this.form.houseInfo.splice(index, 1)
      
      // 清理对应的图片引用
      this.$nextTick(() => {
        const refKey = 'houseImage_' + index
        if (this.$refs[refKey]) {
          this.$refs[refKey][0].clearImages()
        }
      })
    },
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.form.communityId = getCommunityId()
            // 确保 salesInfo 是一个 JSON 字符串
            // 确保 houseInfo 是一个 JSON 字符串
            const formData = {
              ...this.form,
              salesInfo: JSON.stringify(this.form.salesInfo),
              houseInfo: JSON.stringify(this.form.houseInfo)
            }
            await saveBuilding(formData)
            this.$message.success(this.$t('common.operationSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          } catch (error) {
            console.error('保存楼盘失败:', error)
          }
        }
      })
    },
    handleClose() {
      if (this.$refs.buildingDescEditor) {
        this.$refs.buildingDescEditor.clear();
      }
      if (this.$refs.featuresEditor) {
        this.$refs.featuresEditor.clear();
      }
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
.house-info-container,
.sales-info-container {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 15px;
}

.house-item,
.sales-item {
  padding: 10px 0;
  border-bottom: 1px dashed #ebeef5;
}

.house-item:last-child,
.sales-item:last-child {
  border-bottom: none;
}

.el-button.el-button--danger.is-circle {
  padding: 8px;
  min-width: auto;
}
</style>